import { createArticleSectionSelection } from '../templates/size-guide'
import { getSelectedValueByFieldsetElementOrNull } from '@surf-turf/nemo/assets/utils-product'
import { listenForUpdatesOnModalState } from '@surf-turf/nemo/assets/utils-events'

class SizeGuide extends HTMLElement {
  constructor() {
    super()

    const sizeGuideElement = this
    const sizeGuideSelectorElement = sizeGuideElement.querySelector('fieldset[name="productSelector"]')
    const allInputElementsOfSelectorElement = sizeGuideSelectorElement.querySelectorAll('input')
    const arrayOfAllInputElements = [...allInputElementsOfSelectorElement]
    const firstInputElement = arrayOfAllInputElements[0]
    const sizeGuideHolderMainElement = sizeGuideElement.querySelector('.article-holder')
    const articleActiveFieldsetElement = sizeGuideHolderMainElement.querySelector('.article-active-fieldset')
    const articleDataJson = sizeGuideElement.querySelector('.article-data')
    const articleDataObject = articleDataJson
      ? JSON.parse(articleDataJson.innerHTML).articles
      : null

    const setInputActive = (deeplinkTargetElement) => {
      arrayOfAllInputElements.find((inputElement) => {
        if (inputElement == deeplinkTargetElement) {
          inputElement.checked = true
        }
      })
    }

    const findCorrectArticleDataWithDeeplinkTarget = (deeplinkValue) => articleDataObject.find((articleData) => articleData.title === deeplinkValue)

    /**
     * Update article.
     * 
     * @param {object} deeplinkTarget 
     */
    const updateArticle = (deeplinkTarget) => {
      const deeplinkValue = deeplinkTarget.value
      const correctArticleData = findCorrectArticleDataWithDeeplinkTarget(deeplinkValue)
      const allTitles = []

      if (correctArticleData.specifications) {
        allTitles.push('Size chart')
      }

      if (correctArticleData.sections) {
        allTitles.push(...correctArticleData.sections.map((section) => section.id))
      }

      const inputElements = createArticleSectionSelection(allTitles)
      articleActiveFieldsetElement.innerHTML = ''
      articleActiveFieldsetElement.insertAdjacentHTML('afterbegin', inputElements.join(''))
    }

    /**
     * Handle update article.
     * 
     * @param {*} event 
     */
    const handleUpdateArticle = (event) => {
      const deeplinkTarget = getSelectedValueByFieldsetElementOrNull(sizeGuideSelectorElement)

      if (deeplinkTarget) {
        const deepLinkTargetElement = sizeGuideSelectorElement.querySelector(`input[value="${deeplinkTarget}"`)

        setInputActive(deepLinkTargetElement)
        updateArticle(deepLinkTargetElement)
      } else {
        setInputActive(firstInputElement)
        updateArticle(firstInputElement)
      }
    }

    /**
     * Listen for modal open events.
     */
    listenForUpdatesOnModalState((event) => {
      const targetId = event.detail.targetId
      const state = event.detail.state

      if (targetId === 'sizeGuide' && state === 'open') {
        const deeplinkTarget = event.detail.deeplinkTarget

        if (deeplinkTarget) {
          const deepLinkTargetElement = sizeGuideSelectorElement.querySelector(`input[value="${deeplinkTarget}"`)

          setInputActive(deepLinkTargetElement)
          updateArticle(deepLinkTargetElement)
        } else {
          setInputActive(firstInputElement)
          updateArticle(firstInputElement)
        }
      }
    })

    setInputActive(firstInputElement)
    updateArticle(firstInputElement)

    // Add event listener for section selector.
    sizeGuideSelectorElement.addEventListener('change', (event) => handleUpdateArticle(event))
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get('size-guide') === undefined) {
  customElements.define('size-guide', SizeGuide)
}
